import Immutable from 'immutable';

const TaskTypeRecord = Immutable.Record({
  code: undefined,
  name: undefined,
  isValid: undefined,
  description: undefined,
});

export default class TaskType extends TaskTypeRecord { }



// WEBPACK FOOTER //
// ./data/Tasks/TaskType/model.js